export enum SupportedFileType {
    Bpm = 'bpm',
    Csv = 'csv',
    Txt = 'txt',
    Xml = 'xml'
}
